import {addStrategyFace } from "../Interfaces/Interfaces"
import * as yup from 'yup';


      const addStrategySchema = yup.object().shape({
        name:yup.string().required('نام اجباری است'),
      });

      const addTenantMissionSchema = yup.object().shape({
        name:yup.string().required('نام اجباری است'),
      });


    export{
        addStrategySchema,
        addTenantMissionSchema
    }